import * as Yup from 'yup';

export interface ManagerFormProps {
    userType: string;
    email: string;
    firstName: string;
    lastName: string;
    language: string;
    title: string;
    phoneNumber: string;
}

/**
 * The editor cannot change the login email, so it is not required there - and it cannot change their
 * kind at all, so that one is absent rather than optional.
 */
export const managersEditFormSchema = Yup.object().shape({
    firstName: Yup.string().max(255).required('schemaRequiredFirstName'),
    lastName: Yup.string().max(255).required('schemaRequiredLastName'),
    language: Yup.string().required('schemaLanguageRequired'),
    // Neither is set at creation, so a manager edited for the first time has both empty.
    title: Yup.string(),
    phoneNumber: Yup.string().max(255),
});

export const managersFormSchema = Yup.object().shape({
    firstName: Yup.string().max(255).required('schemaRequiredFirstName'),
    lastName: Yup.string().max(255).required('schemaRequiredLastName'),
    email: Yup.string().email('schemaValidEmail').max(255).required('schemaRequiredEmail'),
    language: Yup.string().required('schemaLanguageRequired'),
    userType: Yup.string().required('schemaRoleRequired'),
});
